(function () {
  const FAVORITES_KEY = 'vny:favorites';

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function setFavorites(ids) {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids));
  }

  function syncFavoriteState(button) {
    const productId = button.getAttribute('data-product-id');
    const isFavorite = getFavorites().includes(productId);
    button.classList.toggle('is-active', isFavorite);
    button.setAttribute('aria-pressed', isFavorite);
  }

  function syncAllFavorites(root) {
    (root || document).querySelectorAll('[data-vny-favorite]').forEach(syncFavoriteState);
  }

  function handleFavoriteClick(button) {
    const productId = button.getAttribute('data-product-id');
    const current = getFavorites();
    const index = current.indexOf(productId);
    const nowActive = index === -1;

    if (nowActive) {
      current.push(productId);
    } else {
      current.splice(index, 1);
    }

    setFavorites(current);
    button.classList.toggle('is-active', nowActive);
    button.setAttribute('aria-pressed', nowActive);
  }

  // Fallback used when Dawn's section-rendering pipeline can't fully update
  // the drawer (e.g. one of its requested sections fails to resolve) — keeps
  // the header cart count correct independently of that rendering path.
  function refreshCartIconCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartState) {
        var cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;
        var bubble = cartLink.querySelector('.cart-count-bubble');
        var countLabel = bubble && bubble.querySelector('span[aria-hidden="true"]');
        if (countLabel && cartState.item_count > 0 && cartState.item_count < 100) {
          countLabel.textContent = cartState.item_count;
        }
      })
      .catch(function () {});
  }

  function handleQuickAddClick(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.getAttribute('data-variant-id');
    const label = button.querySelector('.vny-product-card__quick-add-label');
    const originalText = label.textContent;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    button.setAttribute('aria-disabled', 'true');
    label.textContent = 'Adding…';

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          label.textContent = response.description || 'Sold out';
          return;
        }

        if (cart) {
          try {
            cart.renderContents(response);
            // source: 'cart-items' tells Dawn's CartItems subscriber (cart.js)
            // this drawer update already happened via renderContents() above,
            // so it skips its own redundant section-rendering re-fetch, which
            // would otherwise race the render just performed and can overwrite
            // it with a separately-timed read (drawer briefly shows no items).
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              productVariantId: variantId,
              cartData: response,
            });
          } catch (renderError) {
            console.error(renderError);
            if (typeof cart.open === 'function') cart.open();
            refreshCartIconCount();
          }
        }

        label.textContent = 'Added';
      })
      .catch(() => {
        label.textContent = 'Error';
      })
      .finally(() => {
        setTimeout(() => {
          label.textContent = originalText;
          button.removeAttribute('aria-disabled');
        }, 1500);
      });
  }

  document.addEventListener('click', (event) => {
    const favoriteButton = event.target.closest('[data-vny-favorite]');
    if (favoriteButton) {
      handleFavoriteClick(favoriteButton);
      return;
    }

    const quickAddButton = event.target.closest('[data-vny-quick-add]');
    if (quickAddButton) {
      handleQuickAddClick(quickAddButton);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncAllFavorites();

    const container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      const observer = new MutationObserver(() => syncAllFavorites());
      observer.observe(container, { childList: true, subtree: true });
    }
  });
})();
